const closeSectionRegisterIfScrollToBlock = () =>{
    if(document.querySelector('.kruse-section-block--anchor-holder--marker')){
        document.addEventListener('click', ev => {
            if(!ev.target.closest('.kruse-section-block--anchor-holder--marker')) return;
            const bar = document.querySelector('.kruse-section-block--anchor-holder');
            bar.classList.remove('kruse-section-block--anchor-holder-extended');
        })
    }
}
export default closeSectionRegisterIfScrollToBlock;